module.exports = __webpack_public_path__ + "img/ylz.27dd9a9b.jpg";